// features/counter/counterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IFSessionStateObject{
  sessionId: number,
  userName: string,
  gaminarCode: string
}

interface IUserStateObject{
  userName: string | undefined,
  email: string | undefined,
}

// Define a type for the slice state
interface FSessionState {
  session: IFSessionStateObject | null;
  user: IUserStateObject | null;
}

// Define the initial state using that type
const initialState: FSessionState = {
    session: {sessionId : -1, userName: '', gaminarCode: ""},
    user: {userName: '', email: ''}
};

const fSessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setFSession: (state, action: PayloadAction<IFSessionStateObject>) => {
      state.session = action.payload;
      console.log("fSession", action.payload);
    },
    setFUser: (state, action: PayloadAction<IUserStateObject>) => {
      state.user = action.payload;
      console.log("fUser", action.payload);
    }
  }
});

export const { setFSession, setFUser } = fSessionSlice.actions;

export default fSessionSlice.reducer;
